import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Products from './pages/products';
import PageNotFound from './pages/PageNotFound';
import Customer from './pages/customer';
import Rep from './pages/rep';
import Login from './pages/Login';
import ProtectedRoute from './components/ProtectedRoute';
import { Provider } from 'react-redux';
import store from './redux/store';
import { ToastContainer } from 'react-toastify';
import Orders from './pages/orders';
import OrderDetail from './pages/orders/OrderDetail';
import CreateOrder from './pages/orders/CreateOrder';
import OrderItems from './pages/orderItems';
import Banks from './pages/banks';
import Payments from './pages/payments';
import PrivacyPolicy from './pages/privacyPolicy';
import DispatchedItems from './pages/orderItems/DispatchedItems';
import Vendors from './pages/vendors';
import Goods from './pages/goods';

function App() {
    return (
        <Provider store={store}>
            <BrowserRouter>
                <Routes>
                    {/* Public Routes */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />

                    {/* Protected Routes for Admin */}
                    <Route element={<ProtectedRoute allowedRoles={['admin', 'super-admin']} />}>
                        <Route path="/" element={<Rep />} />
                        <Route path="/customers" element={<Customer />} />
                        <Route path="/products" element={<Products />} />
                        <Route path="/orders" element={<Orders />} />
                        <Route path="/orders/create" element={<CreateOrder />} />
                        <Route path="/orders/detail/:orderId" element={<OrderDetail />} />
                        <Route path="/order-items" element={<OrderItems />} />
                        <Route path="/dispatched-items" element={<DispatchedItems />} />
                        <Route path="/payments" element={<Payments />} />
                        <Route path="/banks" element={<Banks />} />
                        <Route path="/vendors" element={<Vendors />} />
                        <Route path="/goods" element={<Goods />} />
                    </Route>

                    {/* Protected Routes for Item Summary */}
                    <Route element={<ProtectedRoute allowedRoles={['item-summary']} />}>
                        <Route path="/de-item-summary" element={<OrderItems />} />
                    </Route>

                    {/* Protected Routes for Products */}
                    <Route element={<ProtectedRoute allowedRoles={['data-entry']} />}>
                        <Route path="/de-products" element={<Products />} />
                    </Route>

                    {/* Protected Routes for Payments */}
                    <Route element={<ProtectedRoute allowedRoles={['payments', 'cash-payments']} />}>
                        <Route path="/de-payments" element={<Payments />} />
                    </Route>

                    {/* Protected Routes for Dispatch User */}
                    <Route element={<ProtectedRoute allowedRoles={['dispatch']} />}>
                        <Route path="/d-reps" element={<Rep />} />
                        <Route path="/d-customers" element={<Customer />} />
                        <Route path="/d-products" element={<Products />} />
                        <Route path="/d-orders" element={<Orders />} />
                        <Route path="/d-orders/create" element={<CreateOrder />} />
                        <Route path="/d-orders/detail/:orderId" element={<OrderDetail />} />
                        <Route path="/d-order-items" element={<OrderItems />} />
                        <Route path="/d-dispatched-items" element={<DispatchedItems />} />
                        <Route path="/d-goods" element={<Goods />} />
                    </Route>

                    {/* Protected Routes for Account User */}
                    <Route element={<ProtectedRoute allowedRoles={['account']} />}>
                        <Route path="/a-payments" element={<Payments />} />
                        <Route path="/a-banks" element={<Banks />} />
                        <Route path="/a-vendors" element={<Vendors />} />
                    </Route>

                    {/* Catch-all for unknown paths */}
                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            </BrowserRouter>
            <ToastContainer />
        </Provider>
    );
}

export default App;
